@let selectedDeal = (selectedDeal$ | async);
@let errorMsg = (errorMsg$ | async);
<mat-card class="detail-card" valumizeCardContextMenu [commentSlug]="'deal-cashflows'">
    <mat-card-header class="detail-card-header">
        <mat-card-title data-test="title">Deal Cash Flows</mat-card-title>
    </mat-card-header>
    <mat-card-content class="detail-card-content">
        @if (errorMsg !== '') {
            <valumize-info-panel [appearance]="'ERROR'" [message]="errorMsg ?? ''"></valumize-info-panel>
        }

        @if ((selectedDealIsNotInit$ | async) && selectedDeal && selectedDeal.id) {
            <mat-tab-group selectedIndex="0">
                <mat-tab label="Weighted" data-test="tab-weighted">
                    <valumize-deal-cashflow-table
                        [dealId]="selectedDeal.id"
                        [scenarioType]="'WEIGHTED'"
                        [displaySecondaryColumns]="displaySecondaryColumns"
                        [displayPatternColumns]="displayPatternColumns"
                        [displayHurdleColumns]="displayHurdleColumns"
                        [isSensitivityView]="isSensitivityView">
                    </valumize-deal-cashflow-table>
                </mat-tab>
                <mat-tab label="Low" data-test="tab-low">
                    <valumize-deal-cashflow-table
                        [dealId]="selectedDeal.id"
                        [scenarioType]="'LOW'"
                        [displaySecondaryColumns]="displaySecondaryColumns"
                        [displayPatternColumns]="displayPatternColumns"
                        [displayHurdleColumns]="displayHurdleColumns"
                        [isSensitivityView]="isSensitivityView">
                    </valumize-deal-cashflow-table>
                </mat-tab>
                <mat-tab label="Base" data-test="tab-base">
                    <valumize-deal-cashflow-table
                        [dealId]="selectedDeal.id"
                        [scenarioType]="'BASE'"
                        [displaySecondaryColumns]="displaySecondaryColumns"
                        [displayPatternColumns]="displayPatternColumns"
                        [displayHurdleColumns]="displayHurdleColumns"
                        [isSensitivityView]="isSensitivityView">
                    </valumize-deal-cashflow-table>
                </mat-tab>
                <mat-tab label="High" data-test="tab-high">
                    <valumize-deal-cashflow-table
                        [dealId]="selectedDeal.id"
                        [scenarioType]="'HIGH'"
                        [displaySecondaryColumns]="displaySecondaryColumns"
                        [displayPatternColumns]="displayPatternColumns"
                        [displayHurdleColumns]="displayHurdleColumns"
                        [isSensitivityView]="isSensitivityView">
                    </valumize-deal-cashflow-table>
                </mat-tab>
            </mat-tab-group>
        }
    </mat-card-content>
    <mat-card-actions class="detail-card-actions">

        @if ((selectedDealIsNotInit$ | async) && selectedDeal && selectedDeal.id) {
            <div>
                <button [matMenuTriggerFor]="menu" aria-label="More options" mat-icon-button (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="toggleSecondaryColumns()" disableRipple>
                        <mat-icon>{{ displaySecondaryColumns ? 'visibility' : 'visibility_off' }}</mat-icon>
                        <span>Secondary Cash Flows</span>
                    </button>
                    @if (displaySecondaryColumns) {
                        <button mat-menu-item (click)="toggleHurdleColumns()" disableRipple>
                            <mat-icon>{{ displayHurdleColumns ? 'visibility' : 'visibility_off' }}</mat-icon>
                            <span>Hurdle</span>
                        </button>
                        <button mat-menu-item (click)="togglePatternColumns()" disableRipple>
                            <mat-icon>{{ displayPatternColumns ? 'visibility' : 'visibility_off' }}</mat-icon>
                            <span>Patterns</span>
                        </button>
                    }
                </mat-menu>
            </div>
        }
        <valumize-card-comments-button [commentSlug]="'deal-cashflows'"></valumize-card-comments-button>
    </mat-card-actions>
</mat-card>
